
export class LegacySquirrelUserDto {
    id!:number;
    name!:string;
    prename!:string;
    login!:string;
    email!:string;
    isAdmin!:boolean;
}

export class Sq3IdPairDto {
    userId!:number;
    sq3Id!:string;
}

export class UserListMigrationResponse {
    Users!: LegacySquirrelUserDto[];
    UnMigratedUsers!:number
    Error!:string;    
}